/* eslint-disable camelcase */
const selectors = {
  video_wrapper: '[data-video-wrapper]',
  src_desktop: '[data-video-desktop-source]',
  src_mobile: '[data-video-mobile-source]',
  autoplay: '[data-video-autoplay]',
  video_player: '[data-video-player]',
  video_player_source: '[data-video-player-source]',
};
class VideoPlayer extends HTMLElement {
  constructor() {
    super();

    this.src_desktop = this.querySelector(selectors.src_desktop);
    this.src_mobile = this.querySelector(selectors.src_mobile);
    this.autoplay = this.querySelector(selectors.autoplay);
    this.video_wrapper = this.querySelector(selectors.video_wrapper);
    this.video_player = this.querySelector(selectors.video_player);
    this.video_player_source = this.querySelector(
      selectors.video_player_source
    );
    this.large_screen = window.matchMedia('(min-width: 768px)');

    this.initialiseVideo();

    window.addEventListener('resize', () => {
      this.initialiseVideo();
    });

    this.playPauseToggle();
  }

  initialiseVideo() {
    if (this.large_screen.matches || !this.hasVideoLinkMobile()) {
      this.playDesktop();
    } else {
      this.playMobile();
    }
  }

  playDesktop() {
    if (this.hasVideoLinkDesktop()) {
      const src_desktop = this.src_desktop.dataset.videoDesktopSource;
      this.setVideoSrcAndPlay(src_desktop);
    }
  }

  playMobile() {
    if (this.hasVideoLinkMobile()) {
      const src_mobile = this.src_mobile.dataset.videoMobileSource;
      this.setVideoSrcAndPlay(src_mobile);
    }
  }

  setVideoSrcAndPlay(src) {
    if (this.video_player_source.src !== src) {
      this.video_player_source.src = src;
      this.video_player.load();
    }

    if (this.autoplay.dataset.videoAutoplay === 'true') {
      this.video_player.play();
    }
  }

  playPauseToggle() {
    this.video_wrapper.addEventListener('click', () => {
      if (this.video_player.paused) {
        this.video_player.play();
      } else {
        this.video_player.pause();
      }
    });
  }

  hasVideoLinkDesktop() {
    return this.src_desktop.dataset.videoDesktopSource.length > 0;
  }

  hasVideoLinkMobile() {
    return this.src_mobile.dataset.videoMobileSource.length > 0;
  }
}

customElements.define('video-player', VideoPlayer);
